import { Outlet, createFileRoute } from '@tanstack/react-router'

// Layout route para /dashboard/$dashboardId/imoveis/$imovelId
// Este arquivo serve como layout para rotas filhas dentro de $imovelId (ex: /editar)
// Renderiza o Outlet para rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId',
)({
  component: function ImovelDetailLayout() {
    return <Outlet />
  },
})

